import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=455d0db9&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455d0db9')) {
      api.createRecord('455d0db9', component.options)
    } else {
      api.reload('455d0db9', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=455d0db9&", function () {
      api.rerender('455d0db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/imageCarousel.vue"
export default component.exports